import { ShieldAlert } from "lucide-react";

export const Disclaimers = () => (
  <section data-testid="disclaimers-section" className="bg-yellow-50 py-14">
    <div className="max-w-5xl mx-auto px-6">
      <div className="bg-white rounded-[2rem] p-7 sm:p-9 border-4 border-emerald-100">
        <h3 className="font-display font-bold text-2xl text-emerald-700 flex items-center gap-2 mb-4">
          <ShieldAlert className="w-7 h-7 text-pink-500" /> Important Disclaimers
        </h3>
        <p className="text-emerald-800 font-medium leading-relaxed">
          WonderStarzLV is not affiliated with or endorsed by the Las Vegas-Clark County Library
          District. This program operates independently and may use public/community library
          spaces or nearby approved locations. Schedule, locations, and activities are subject to
          change. Parent/guardian participation in registration confirms agreement to all program
          policies, safety rules, liability waivers, and pickup procedures.
        </p>
      </div>
    </div>
  </section>
);
